/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateModuloAggiuntivoDto } from '../../models/update-modulo-aggiuntivo-dto';

export interface ApiModuloAggiuntivoUpdateModuloAggiuntivoListForCorpoPost$Params {
    /**
     * Oggetto contenente la configurazione dei moduli aggiuntivi per il corpo
     */
    body: UpdateModuloAggiuntivoDto;
}

export function apiModuloAggiuntivoUpdateModuloAggiuntivoListForCorpoPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiModuloAggiuntivoUpdateModuloAggiuntivoListForCorpoPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, apiModuloAggiuntivoUpdateModuloAggiuntivoListForCorpoPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
    );
}

apiModuloAggiuntivoUpdateModuloAggiuntivoListForCorpoPost.PATH = '/api/modulo-aggiuntivo/update-modulo-aggiuntivo-list-for-corpo';
